import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../utils/utilities";

const initialState = {
  data: [],
  meta: {},
  error: undefined,
  success: undefined,
  loading: false,
  reload: false,
};

const getUserNotificationStatisticsStart = (state, action) => {
  return updateObject(state, {
    error: undefined,
    data: [],
    meta: {},
    loading: true,
  });
};

const getUserNotificationStatisticsSuccess = (state, action) => {
  return updateObject(state, {
    data: action.data,
    meta: action.meta,
    error: undefined,
    loading: false,
  });
};

const getUserNotificationStatisticsFail = (state, action) => {
  return updateObject(state, {
    error: action.error[0].message,
    data: [],
    meta: {},
    loading: false,
  });
};

const addSmsLimitStart = (state, action) => {
  return updateObject(state, {
    loading: true,
    error: undefined,
    reload: false,
    success: undefined,
  });
};

const addSmsLimitSuccess = (state, action) => {
  return updateObject(state, {
    error: undefined,
    loading: false,
    reload: true,
    success: "Sms limit added successfully.",
  });
};

const addSmsLimitFail = (state, action) => {
  return updateObject(state, {
    error:
      action.error[0].msg ? action.error[0].message: action.error[0].msg,
    loading: false,
    reload: false,
    success: undefined,
  });
};

const userNotificationStatistics = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_USER_NOTIFICATIONS_STATISTICS_START:
      return getUserNotificationStatisticsStart(state, action);
    case actionTypes.GET_USER_NOTIFICATIONS_STATISTICS_SUCCESS:
      return getUserNotificationStatisticsSuccess(state, action.data);
    case actionTypes.GET_USER_NOTIFICATIONS_STATISTICS_FAIL:
      return getUserNotificationStatisticsFail(state, action);
    case actionTypes.ADD_SMS_LIMIT_START:
      return addSmsLimitStart(state, action);
    case actionTypes.ADD_SMS_LIMIT_SUCCESS:
      return addSmsLimitSuccess(state, action.data);
    case actionTypes.ADD_SMS_LIMIT_FAIL:
      return addSmsLimitFail(state, action);
    default:
      return state;
  }
};

export default userNotificationStatistics;
